import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "page page--home page--shop-selector text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "customer-logo" }, null, -1)
const _hoisted_3 = { class: "shop-selector" }

import {IonContent, IonPage, onIonViewWillEnter} from '@ionic/vue';
import ShopSelector from '@/components/ShopSelector.vue';
import {ApplicationSettings, Shop} from '@/types';
import router from '@/router';
import {onBeforeMount} from 'vue';
import {ShopStore} from '@/stores/shop';
import {CartStore} from '@/stores/cart';
import {useI18n} from 'vue-i18n'
import {OrderType} from "@/enums";
import {car} from "ionicons/icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

/* imports */
const shopStore = ShopStore();
    const cartStore = CartStore();

    const { t } = useI18n();

    /* Reactive */

    /* Ref */

    /* Computed */
/*
    const  randomNotification = () => {
        if(Notification.permission !== "granted"){
            Promise.resolve(Notification.requestPermission()).then(function(permission) {
                if(permission !== "granted")
                    return;
    
                randomNotification();
            });
        } else {
            new Notification("Order ready", {
                body: "Your order is ready for pickup",
                icon: "http://localhost:8100/assets/icon/sibylla/android-chrome-192x192.png"
            });
            setTimeout(randomNotification, 30000);
        }
    }

    let installprompt = null; 
    window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        const installButton = document.querySelector("#install");
        installButton?.removeAttribute("hidden");
        installprompt = e;
        // Stash the event so it can be triggered later.
        // @ts-ignore
        //window.deferredPrompt = e;
        // Update UI notify the user they can add to home screen
        //btnAdd.style.display = 'block';
    });

    const onInstall = async ()=>{
        if(!installprompt){
            return;
        }
        await installprompt.prompt();
    };    
 */

    /* Functions */
    const onSelectShop = (item: Shop) => {
        if (item) {
            if (cartStore.state.items.length > 0 && cartStore.state.shopId) {
                //If restaurant changed then clear cartStore
                if (!cartStore.compareShop(item.id)) {
                    cartStore.clear(true);                    
                }
            }
        }

        shopStore.set(item);
        cartStore.setShop(item.id, item.name);
        
        console.log(router.currentRoute.value.query);
        
        const query = {
          redirectToArticle: router.currentRoute.value.query.redirectToArticle
        };
        
        if(cartStore.state.settings.orderTypes.length == 1 && cartStore.getOrderType()){
            router.push({
                name: 'categoriesPage',
                params: { shopId: item.id },
                query: query
            });
            return;
        }

        router.push({
            name: 'shopPage',
            params: { 
              shopId: item.id 
            },
            query: query
        });
    };

    onIonViewWillEnter(() => {
        // clear previous restaurant choices
        shopStore.clear();
    })

    onBeforeMount(() => {
        // clear previous restaurant choices
        shopStore.clear();
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", null, _toDisplayString(_unref(t)("home.header")), 1),
              (_unref(cartStore).state.initiated)
                ? (_openBlock(), _createBlock(ShopSelector, {
                    key: 0,
                    onSelectShop: onSelectShop
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})